import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const ADMIN_PANEL = "adminPanel";
const GET_ORDER_STATISTICS = "getOrderStatistics";
const SEND_EMAIL = "sendEmail";
const GET_REVENUE_FOR_YEAR = "getRevenueForYear";
const GET_CREATION_DATE_OF_FIRST_ORDER = "getCreationDateOfFirstOrder";

const MUTATION_KEYS = {
  [SEND_EMAIL]: [ADMIN_PANEL, SEND_EMAIL],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(ADMIN_PANEL, {
  [GET_ORDER_STATISTICS]: null,
  [GET_REVENUE_FOR_YEAR]: (params: Parameters<Service[typeof GET_REVENUE_FOR_YEAR]>[0]) => [params],
  [GET_CREATION_DATE_OF_FIRST_ORDER]: null,
});

export {
  GET_CREATION_DATE_OF_FIRST_ORDER,
  GET_ORDER_STATISTICS,
  GET_REVENUE_FOR_YEAR,
  MUTATION_KEYS,
  QUERY_KEYS,
  SEND_EMAIL,
};
